/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { ReactComponent as WarningIcon } from "images/snackbar/warn.svg";
import { ReactComponent as SuccessIcon } from "images/snackbar/success.svg";
import { ReactComponent as ErrorIcon } from "images/snackbar/error.svg";
import { ReactComponent as InfoIcon } from "images/snackbar/info.svg";
import sass from "./snack.module.sass";
import cn from "classnames";

enum Position {
	"top-center",
	"top-left",
	"top-right",
}

enum Factor {
	"full",
	"light",
}

const positionData = [
	"top: 10px; left: 50%; transform: translateX(-50%); flex-direction: column",
	"top: 10px; left: 10px; flex-direction: column",
	"top: 10px; right: 10px; flex-direction: column",
] as const;

const Icon = {
	success: SuccessIcon,
	error: ErrorIcon,
	info: InfoIcon,
	warn: WarningIcon,
};

export interface IEntrySnack {
	factor: keyof typeof Factor;
	type: "success" | "error" | "warn" | "info";
	title: any;
	position?: keyof typeof Position;
	delay?: number | false;
}
interface ICreateSnack extends IEntrySnack {
	index: number;
}
interface ISnack extends IEntrySnack {
	remove: () => void;
	index: number;
}

const Item: React.FC<ISnack> = ({ remove, type, title, position = "top-right", delay = 1500, factor }) => {
	const [exit, setExit] = useState(false);

	const exitType = position?.includes("bottom") ? "exit-bottom" : "exit-top";

	const closeThis = () => {
		setExit(true);
		setTimeout(() => {
			remove();
		}, 200);
	};
	useEffect(() => {
		if (delay) {
			setTimeout(() => {
				setTimeout(() => {
					setExit(true);
					setTimeout(() => {
						remove();
					}, 200);
				}, delay);
			}, 200);
		}
		//eslint-disable-next-line
	}, [delay]);

	const ICON = Icon[type];
	return (
		<div className={cn(sass.snack_wrapper, sass[`${factor}__${type}`], { [sass[exitType]]: exit })}>
			<div className={sass.snack_wrapper__content}>
				<div className={sass.snack_wrapper__message}>
					{factor === "light" && (
						<div>
							<ICON />
						</div>
					)}
					{title}
				</div>
				{factor === "light" && (
					<div className={sass.btn} onClick={closeThis}>
						Понятно
					</div>
				)}
			</div>
		</div>
	);
};

class Snackbar {
	private id = "wrapper-snackbar";
	private root: any = null;
	private container: HTMLElement | null = null;
	private snacks: ICreateSnack[] = [];

	constructor() {
		this.render = this.render.bind(this);
	}

	private createJSX() {
		this.root.render(
			<>
				{this.snacks.map((_) => (
					<Item key={_.index} remove={() => this.removeItem(_.index)} {..._} />
				))}
			</>,
		);
	}

	private init(position: keyof typeof Position = "top-right") {
		if (!this.container) {
			this.container = document.getElementById(this.id);
			if (!this.container) {
				const wrapper = document.createElement("div");
				wrapper.id = this.id;
				if (position) {
					wrapper.style.cssText = positionData[Position[position]];
				}
				document.body.append(wrapper);
				this.container = document.getElementById(this.id);
			}
		}

		if (!this.root) {
			this.root = ReactDOM.createRoot(this.container!);
		}
	}

	private removeItem(index: number) {
		this.snacks = this.snacks.filter((_) => _.index !== index);
		if (!this.snacks.length) {
			this.container?.remove();
			this.container = null;
			this.root = null;
		} else {
			this.createJSX();
		}
	}

	private createSnack(snack: IEntrySnack) {
		const newSnack = { ...snack, index: Date.now() + Math.ceil(Math.random() * 100) };
		this.snacks = [...this.snacks, newSnack];
	}

	render(snack: IEntrySnack) {
		this.createSnack(snack);
		this.init(snack.position);
		this.createJSX();
	}
}

export default new Snackbar().render;
